import { connect } from "react-redux";
import { string, func, bool, arrayOf, shape } from "prop-types";
import TextInput from "@shared/v2/TextInput/TextInput";
import ContactInfoCard from "../component/ContactInfoCard";
import Contacts from "../component/Contacts";

const ContactInformation = ({
  setComments,
  comments,
  agent,
  agentAvatar,
  addContactCoop,
  setAddContactAdditional,
  setAddContactCoop,
  addContactAdditional,
  cooperatingAgent,
  setCooperatingAgent,
  newCooperatingAgent,
  setNewCooperatingAgent,
  newAdditionalContact,
  setNewAdditionalContact,
  additionalContact,
  setAdditionalContact,
}) => (
  <div>
    <div className="tw-py-[32px]">
      <div className="tw-text-14px tw-leading-[20px] tw-font-semibold tw-text-gray-75">
        Share Contact Information
      </div>
      <div className="tw-pt-[5px] tw-text-14px tw-leading-[20px] tw-font-normal tw-text-gray-75">
        This contact information will be shared with Blueprint. You can select any clients or collaborators
        who have been added to the transaction or add additional contacts.
        <div className="tw-pt-[20px]">
          Providing as much information as possible at this stage will greatly speed up Blueprint's process.
        </div>
      </div>
    </div>
    <div>
      <div className="tw-pb-[9px] tw-text-14px tw-leading-[20px] tw-font-semibold tw-text-gray-50">
        <span className="tw-capitalize">Primary Agent</span>
      </div>
      <ContactInfoCard
        name={agent || "No primary agent"}
        avatarImg={agentAvatar}
        role={agent ? "Primary Agent" : ""}
      />
    </div>
    <div className="tw-pt-[28px]"></div>
    <Contacts
      setAddContact={setAddContactCoop}
      addContact={addContactCoop}
      newContacts={newCooperatingAgent}
      setNewContacts={setNewCooperatingAgent}
      setContact={setCooperatingAgent}
      contacts={cooperatingAgent}
      contactType="co-op"
    />
    <div className="tw-pt-[28px]"></div>
    <Contacts
      setAddContact={setAddContactAdditional}
      addContact={addContactAdditional}
      setNewContacts={setNewAdditionalContact}
      newContacts={newAdditionalContact}
      setContact={setAdditionalContact}
      contacts={additionalContact}
      contactType="additional"
    />
    <div className="tw-pt-[28px]"></div>
    <TextInput
      label="Comments"
      className="!tw-w-[554px]"
      multiline
      value={comments}
      rows={5}
      name="comments"
      placeholder="Anything else you'd like Blueprint to know about this title?"
      onChange={(e) => {
        setComments(e.target.value);
      }}
    />
  </div>
);

const mapStateToProps = (state) => ({
  agent: state.tdpDetailsReducer.primaryAgentDetails?.agent,
  agentAvatar: state.tdpDetailsReducer.primaryAgentDetails?.agentAvatar,
});

ContactInformation.propTypes = {
  agent: string,
  agentAvatar: string,
  setAddContactCoop: func,
  setComments: func,
  comments: string,
  addContactCoop: bool,
  addContactAdditional: bool,
  setAddContactAdditional: func,
  cooperatingAgent: arrayOf(shape({})),
  setCooperatingAgent: func,
  newCooperatingAgent: arrayOf(shape({})),
  setNewCooperatingAgent: func,
  newAdditionalContact: arrayOf(shape({})),
  setNewAdditionalContact: func,
  additionalContact: arrayOf(shape({})),
  setAdditionalContact: func,
};

ContactInformation.defaultProps = {
  agent: "",
  agentAvatar: null,
  setComments: null,
  comments: "",
  setAddContactCoop: null,
  addContactCoop: false,
  setAddContactAdditional: null,
  addContactAdditional: false,
  cooperatingAgent: [],
  setCooperatingAgent: null,
  newCooperatingAgent: [],
  setNewCooperatingAgent: null,
  newAdditionalContact: [],
  setNewAdditionalContact: null,
  additionalContact: [],
  setAdditionalContact: null,
};

export default connect(mapStateToProps)(ContactInformation);
